import { createFileRoute } from '@tanstack/react-router';
import { SignupForm } from '../components/auth/signup-form.js';

export const Route = createFileRoute('/signup')({
  component: SignupRoute,
});

function SignupRoute() {
  return (
    <main className="flex min-h-svh items-center justify-center bg-muted p-6 md:p-10">
      <SignupForm mode="signup" />
    </main>
  );
}
